exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".search {\n  display: grid;\n  grid-template-columns: max-content 1fr;\n}\n.search .dropdown-toggle {\n  border-bottom-right-radius: 0;\n  border-top-right-radius: 0;\n}\n.tags-counter {\n  background: #007bff;\n  height: 20px;\n  width: 20px;\n  border-radius: 150px;\n  font-weight: 600;\n  position: absolute;\n  font-size: 0.8em;\n  left: -10px;\n  top: -10px;\n}\n", ""]);

// exports
